import { getAxiosRequestConfigBoltBackend, newRequest } from 'utils/request.ts'
import { Methods, Response } from 'types/request.ts'
import { IS_BETA } from 'constants/envs.ts'
import { log, setLogContext, truncateStringForLogging } from 'utils/logging.ts'
import { Flow } from 'types/logging.ts'
import { AddContractData } from 'features/contracts/add/types.ts'
import { parseCreateContractData } from './createContract.utils.ts'
import { AllProducts } from 'types/products.ts'
import { CreateContractRequestBody } from '@boltenergy-be/shared'

export const createContract = async (data: AddContractData, allProducts: AllProducts, skipCreditCheck = false): Promise<Response> => {
  if (IS_BETA) {
    log({ error: 'Cannot create a contract in beta', identifier: '[BETA:contracts]' })
    return { success: false }
  }

  setLogContext('create_contract_raw_inputs', data)

  try {
    const body = await parseCreateContractData(data, allProducts, skipCreditCheck)
    setLogContext(
      'create_contract_request_body',
      body.contract.uploadDataUrls?.energyTransferDocument
        ? ({
            ...body,
            contract: {
              ...body.contract,
              uploadDataUrls: {
                ...body.contract.uploadDataUrls,
                energyTransferDocument: truncateStringForLogging(body.contract.uploadDataUrls.energyTransferDocument)
              }
            }
          } satisfies CreateContractRequestBody)
        : body
    )

    const res = await newRequest(getAxiosRequestConfigBoltBackend(Methods.POST, '/registrations/contracts', body))

    if (!res.success) {
      log({
        error: res?.message || 'unknown error with createContract',
        identifier: `[${Flow.CONTRACT}:createContract${res?.errorCode ? `:${res.errorCode}` : ''}]`,
        errorCode: res?.errorCode
      })
    }

    return res
  } catch (error) {
    log({
      error: error instanceof Error ? error : 'Unknown error in createContract',
      identifier: `[${Flow.CONTRACT}:CATCH:createContract]`
    })
    return { success: false }
  }
}
